import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { LoginEventDto, PagedResult, QueryOptions } from '../lib/types';

export function useLoginLog(options: QueryOptions) {
  const params = new URLSearchParams();
  if (options.page) params.set('page', String(options.page));
  if (options.pageSize) params.set('pageSize', String(options.pageSize));
  if (options.sortBy) params.set('sortBy', options.sortBy);
  if (options.sortDesc != null) params.set('sortDesc', String(options.sortDesc));
  if (options.filter) params.set('filter', options.filter);

  return useQuery({
    queryKey: ['admin', 'login-log', options],
    queryFn: () => apiClient.get<PagedResult<LoginEventDto>>(`/api/admin/login-log?${params}`),
  });
}
